export default "__VITE_ASSET__6f3005b4__"